module.exports = __webpack_public_path__ + "static/media/phone2-en.82900c90.png";